export { default } from "./Translation";
export * from "./Translation";
